import { SurfaceAccessWorkspace } from '@/components/surface/SurfaceAccessWorkspace';

export default function SettingsSurfaceAccessPage() {
  return <SurfaceAccessWorkspace mode="tenant" />;
}
